import analytics from '../../../analytics';
import Dialogs from '../../dialogs/a11y-dialog-component';
export const popinTracking = (popin, dialogId, titleId, descId) => {
    const containerPopins = document.getElementById('popins');
    const dialogElement = document.getElementById(dialogId);
    if (!dialogElement || !dialogElement.dataset) {
        return;
    }
    const { onlyOnce } = dialogElement.dataset;
    const storageKey = `popin-${dialogElement.dataset.popinId}`;
    const storageValue = window.localStorage.getItem(storageKey);
    if (onlyOnce === '0' || (onlyOnce === '1' && storageValue === null)) {
        if (onlyOnce === '1') {
            window.localStorage.setItem(storageKey, '1');
        }
        const dialogConfig = {
            labelledbyId: titleId,
            describedbyId: descId,
            show: true,
            backdrop: popin.format !== 'optin_centered',
            disableScroll: popin.format === 'optin_centered',
            onOpen: () => {
                containerPopins && containerPopins.classList.remove('hidden');
                dialogElement && dialogElement.classList.remove('hidden');
                dialogElement.classList.add('flex'); // ensure dialog is flex to trigger fade-in animation
            },
            onClose: () => {
                // Keep the global popins container visible when the banner is active.
                const isBannerVisible = containerPopins?.classList.contains('is-banner-show') ?? false;
                if (!isBannerVisible) {
                    containerPopins && containerPopins.classList.add('hidden');
                }
                dialogElement && dialogElement.classList.add('hidden');
                dialogElement.classList.remove('flex'); // reset to hidden state for next open
            },
        };
        Dialogs.create(dialogId, dialogConfig);
        analytics.dynamicPopin(popin.format === 'optin_centered' ? 'Popin optin centered' : 'Popin optin');
    }
};
